export enum InputDisplay {
  Inline = 'inline',
  InlineSpaced = 'inline-spaced',
  Block = 'block',
}
